export const LabelRoutes = {
  removeContractLabels: '/labels/remove',
  rootLabels: '/labels/root/:userId',
  myLabels: '/labels/mine/:id',
  listRoot: '/labels/list/root/:userId',
  listLabel: '/labels/list', // list
  assign: '/labels/assign',
  createLabel: '/labels/create', // create
  getAllMyLabels: '/labels/my-personal-labels',
};
